<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="box-header">
        <span class="box-header__title">Редактировать данные</span>

        <el-popconfirm
          class="confirmBtn"
          @onConfirm="deleteDepartment"
          title="Вы уверены?"
          confirmButtonText="Да"
          cancelButtonText="Нет"
          confirmButtonType="danger"
          cancelButtonType="default"
        >
          <el-button
            slot="reference"
            class="box-header__button"
            :loading="loadDeleteForm"
            size="mini"
            type="danger"
          >Удалить офис</el-button>
        </el-popconfirm>
      </div>

      <el-form ref="editForm" :rules="editFormRules" :model="office" v-if="office" class="office-form">
        <el-form-item label="Название" prop="title">
          <el-input name="title" autosize placeholder="Введите название офиса..." v-model="office.title"></el-input>
        </el-form-item>
        <el-form-item label="Координаты" prop="coords">
          <div class="coords">
            <el-input placeholder="" v-model="office.x" class="coords__item">
              <template slot="append">Широта</template>
            </el-input>
            <el-input placeholder="" v-model="office.y" class="coords__item">
              <template slot="append">Долгота</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="Адрес" prop="address">
          <el-input
            type="textarea"
            name="address"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="Адрес офиса..."
            v-model="office.address"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loadEditForm" @click="editDepartment()" class="office-form__btn">Обновить</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список приборов офиса</span>
        <el-button
          class="box-header__button"
          @click="addDevice"
          size="mini"
          type="primary"
        >Добавить прибор</el-button>
      </div>

      <template>
        <el-table :data="loadData" class="table" v-loading="loadTable">
          <el-table-column prop="id" label="id" width="80"></el-table-column>
          <el-table-column prop="name" label="Название"></el-table-column>
          <el-table-column prop="title" label="Тип"></el-table-column>
          <el-table-column prop="title" label="Действия" fixed="right" align="center" width="140"></el-table-column>
        </el-table>
      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список услуг</span>
        <el-button
          class="box-header__button"
          @click="editService"
          size="mini"
          type="primary"
        >Добавить услугу</el-button>
      </div>

      <template>
        <el-table :data="loadData" class="table" v-loading="loadTable">
          <el-table-column prop="id" label="id" width="80"></el-table-column>
          <el-table-column prop="name" label="Название"></el-table-column>
          <el-table-column prop="name" label="Длительность"></el-table-column>
          <el-table-column prop="name" label="Стоимость"></el-table-column>
          <el-table-column prop="title" label="HealthyCoin"></el-table-column>
          <el-table-column prop="title" label="Действия" fixed="right" align="center" width="140"></el-table-column>
        </el-table>
      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список товаров</span>
        <el-button
          class="box-header__button"
          @click="addDevice"
          size="mini"
          type="primary"
        >Добавить товар</el-button>
      </div>

      <template>
        <el-table :data="loadData" class="table" v-loading="loadTable">
          <el-table-column prop="id" label="id" width="80"></el-table-column>
          <el-table-column prop="name" label="Название"></el-table-column>
          <el-table-column prop="name" label="Производитель"></el-table-column>
          <el-table-column prop="name" label="Стоимость"></el-table-column>
          <el-table-column prop="title" label="HealthyCoin"></el-table-column>
          <el-table-column prop="title" label="Действия" fixed="right" align="center" width="140"></el-table-column>
        </el-table>
      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <device-add
      :visible="questionAddModal"
      @close="questionAddModal = false"
      @update="loadLogic"
      :listId="getId"
    />

    <device-edit
      :visible="questionEditModal"
      @close="questionEditModal = false"
      @update="loadLogic"
      :device="selectDevice"
      :listId="getId"
    />

    <service-edit
      :visible="serviceModal"
      @close="serviceModal = false"
      @update="loadLogic"
      :listId="getId"
    />

  </div>
</template>

<script>
import DeviceAdd from '@/components/dialog/devices/Add'
import DeviceEdit from '@/components/dialog/devices/Edit'
import ServiceEdit from '@/components/dialog/service/Edit'

export default {
  name: 'cpanel.departments.item',
  data () {
    return {
      editForm: {},
      loadData: null,
      loading: false,
      office: false,
      serviceModal: false,
      questionAddModal: false,
      questionEditModal: false,
      loadEditForm: false,
      loadDeleteForm: false,
      loadTable: false,
      errorLoadCard: false,
      departments: {
        title: null,
        description: null
      },
      selectDevice: null,
      error: null,
      editFormRules: {
        title: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Укажите описание', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.loading = !!1
    this.loadLogic()
  },
  computed: {
    getId () {
      return this.$route.params.id
    }
  },
  components: {
    DeviceAdd,
    DeviceEdit,
    ServiceEdit
  },
  methods: {
    loadLogic () {
      this.$api.departments
        .getItem(this.getId)
        .then((response) => {
          this.office = response.data
          // this.loadData = response.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    },
    handleEdit (id) {
      this.$router.push({
        name: 'cpanel.questionnaire.item',
        params: {
          id
        }
      })
    },
    deleteItem (id, index) {
      this.loadTable = !!1

      this.$api.device
        .delete(id)
        .then(() => {
          this.loadData.questions.splice(index, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка удаления',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loadTable = !!0
        })
    },
    editService (device) {
      this.selectDevice = device
      this.serviceModal = !!1
    },
    addDevice () {
      this.questionAddModal = !!1
    },
    editDepartment () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadEditForm = !!1
          this.$api.departments
            .update(this.getId, this.office)
            .then((response) => {
              this.office = response.data
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные обновлены'
              })
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка сохранения',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadEditForm = !!0
            })
        }
      })
    },
    deleteDepartment () {
      this.loadDeleteForm = !!1
      this.$api.departments
        .delete(this.getId)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Офис удален'
          })
          this.$router.push({ name: 'cpanel.departments.list' })
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка данных',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loadDeleteForm = !!0
        })
    },
    saveSubmit () {}
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 960px;
  margin: 10px auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.coords {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;

  &__item {
    width: 240px;
  }

}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}

.office-form {
  &__btn {
    width: 100%;
    margin-top: 6px;
  }
}
</style>
